import makeStyles from '@mui/styles/makeStyles';

import { Theme } from '../../../../types';

const remittanceFormStyles = makeStyles((theme: Theme) => ({
    containerBorder: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(2),
        '& .MuiFormControl-root': {
            paddingBottom: theme.spacing(1),
            '&:last-child': {
                paddingBottom: 0
            }
        }
    },
    maxHeight: {
        maxHeight: 'fit-content'
    },
    marginTop3: {
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3)
        }
    },
    marginLeft1Top2: {
        margin: theme.spacing(2, 0, 0, 1)
    },
    marginAutoAuto0: {
        margin: 'auto auto 0'
    },
    paddingTop1: {
        paddingTop: theme.spacing(1)
    },
    positionRelative: {
        position: 'relative'
    },
    colorError: {
        color: theme.palette.error.main
    },
    colorPrimary: {
        '&.MuiTextField-root': {
            '& .MuiInputLabel-outlined': {
                color: theme.palette.primary.main
            }
        }
    },
    linkButton: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));

export default remittanceFormStyles;
